@if (isLoading()) {
  <span class="loading loading-dots loading-lg"></span>
}
